export const works = [
  {
    id: "w01",
    title: "夜色的彼端",
    type: "电影",
    year: 2019,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20style%20of%20a%20young%20japanese%20woman%20standing%20in%20a%20rain%20soaked%20neon%20alley%20at%20night%2C%20deep%20blue%20gray%20tones%20with%20warm%20orange%20street%20lamp%20glow%2C%20dramatic%20rim%20lighting%2C%20moody%20atmosphere%2C%20minimalist%20modern%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=okuda-work-01&orientation=portrait",
    director: "松本和也",
    role: "饰 佐仓凛",
    duration: "118 分钟",
    rating: 8.6,
    region: "日本",
    tags: ["都市", "悬疑", "剧情"],
    synopsis:
      "深夜的街道只剩下雨声。佐仓凛在城市边缘寻找失踪多年的姐姐，一步步走进被霓虹掩盖的真相。影片以冷峻的蓝灰影调描绘都市人的孤独，凭细腻的表演获得当年多项影评人提名。",
    featured: true,
  },
  {
    id: "w02",
    title: "东京狂想曲",
    type: "电视剧",
    year: 2020,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20of%20a%20young%20japanese%20woman%20holding%20a%20transparent%20umbrella%20at%20a%20busy%20tokyo%20crossing%2C%20cool%20blue%20gray%20palette%20with%20soft%20orange%20highlights%2C%20editorial%20photography%2C%20shallow%20depth%20of%20field%2C%20elegant%20modern%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=okuda-work-02&orientation=portrait",
    director: "小林悠介",
    role: "饰 藤井茜",
    duration: "全 10 集",
    rating: 8.2,
    region: "日本",
    tags: ["都市", "情感", "群像"],
    synopsis:
      "十个在东京打拼的年轻人，在同一个雨夜擦肩而过。藤井茜是连接所有人的那根线，她记录下每一段擦肩而过的故事。剧集用克制的镜头语言讲述了关于选择与留下的话题。",
    featured: true,
  },
  {
    id: "w03",
    title: "静海之忆",
    type: "电影",
    year: 2021,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20of%20a%20young%20japanese%20woman%20standing%20by%20a%20calm%20grey%20sea%20at%20dusk%2C%20muted%20blue%20grey%20tones%20with%20a%20warm%20orange%20horizon%20line%2C%20soft%20natural%20light%2C%20melancholic%20mood%2C%20minimalist%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=okuda-work-03&orientation=portrait",
    director: "田中启介",
    role: "饰 长谷川澪",
    duration: "124 分钟",
    rating: 8.9,
    region: "日本",
    tags: ["剧情", "家庭", "治愈"],
    synopsis:
      "长谷川澪回到海边的故乡，整理祖母留下的旧屋。潮声里藏着她不敢面对的记忆。影片用极简的场景与大量留白，讲述了一次缓慢而温柔的和解，被誉为其演技代表作。",
    featured: true,
  },
  {
    id: "w04",
    title: "夏日残响",
    type: "短片",
    year: 2018,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20short%20film%20poster%20of%20a%20young%20japanese%20woman%20walking%20through%20a%20golden%20summer%20field%20at%20sunset%2C%20warm%20orange%20tones%20with%20deep%20blue%20shadows%2C%20backlit%20rim%20light%2C%20nostalgic%20summer%20atmosphere%2C%20minimalist%20modern%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=okuda-work-04&orientation=portrait",
    director: "新井恭平",
    role: "饰 少女",
    duration: "24 分钟",
    rating: 8.0,
    region: "日本",
    tags: ["青春", "短片", "夏日"],
    synopsis:
      "一个夏天，一段回不去的蝉鸣。短片以一小时内的黄昏为时间轴，记录少女在田野间最后一次奔跑，是她早期作品中最令人难忘的一段表演。",
    featured: false,
  },
  {
    id: "w05",
    title: "星降之夜",
    type: "电视剧",
    year: 2022,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20of%20a%20young%20japanese%20woman%20standing%20under%20a%20vast%20starry%20night%20sky%20on%20a%20hill%2C%20deep%20navy%20blue%20tones%20with%20a%20faint%20warm%20orange%20glow%20on%20the%20horizon%2C%20long%20exposure%20stars%2C%20ethereal%20atmosphere%2C%20minimalist%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=okuda-work-05&orientation=portrait",
    director: "小林悠介",
    role: "饰 天野诗织",
    duration: "全 8 集",
    rating: 8.4,
    region: "日本",
    tags: ["奇幻", "情感", "治愈"],
    synopsis:
      "天野诗织在一场流星雨后，开始收到来自未来的信。剧集以温柔的节奏探讨时间与遗憾，画面质感与音乐都获得了极高评价，成为当年的现象级话题作品。",
    featured: true,
  },
  {
    id: "w06",
    title: "玻璃之心",
    type: "电影",
    year: 2020,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20of%20a%20young%20japanese%20woman%20reflected%20in%20a%20large%20glass%20window%20indoors%2C%20cool%20blue%20grey%20interior%20with%20warm%20orange%20accent%20light%2C%20double%20exposure%20reflection%2C%20intimate%20mood%2C%20minimalist%20modern%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=okuda-work-06&orientation=portrait",
    director: "松本和也",
    role: "饰 白石千夏",
    duration: "112 分钟",
    rating: 8.3,
    region: "日本",
    tags: ["心理", "剧情", "都市"],
    synopsis:
      "白石千夏是位修复旧玻璃的匠人，她把每一道裂痕都当作故事。直到有一天，一面镜子让她看见了自己缺席的过去。影片以精密的构图与光影设计著称。",
    featured: false,
  },
  {
    id: "w07",
    title: "约定的季节",
    type: "电视剧",
    year: 2019,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20of%20a%20young%20japanese%20woman%20standing%20in%20an%20autumn%20park%20surrounded%20by%20falling%20maple%20leaves%2C%20warm%20orange%20and%20deep%20blue%20gray%20tones%2C%20soft%20golden%20hour%20light%2C%20gentle%20melancholic%20mood%2C%20minimalist%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=okuda-work-07&orientation=portrait",
    director: "田中启介",
    role: "饰 森川结衣",
    duration: "全 12 集",
    rating: 8.1,
    region: "日本",
    tags: ["情感", "家庭", "成长"],
    synopsis:
      "每年秋天，森川结衣都会回到同一座公园。十二集，十二个季节，她用十二封信兑现了和一个人的约定。剧集节奏舒缓，被称为最温柔的一次告别。",
    featured: false,
  },
  {
    id: "w08",
    title: "白色街灯",
    type: "短片",
    year: 2021,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20short%20film%20poster%20of%20a%20young%20japanese%20woman%20walking%20down%20a%20snowy%20quiet%20street%20at%20night%2C%20cold%20blue%20white%20tones%20with%20a%20warm%20orange%20street%20lamp%2C%20falling%20snow%2C%20silent%20atmosphere%2C%20minimalist%20modern%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=okuda-work-08&orientation=portrait",
    director: "新井恭平",
    role: "饰 无名旅人",
    duration: "28 分钟",
    rating: 7.9,
    region: "日本",
    tags: ["短片", "冬日", "文艺"],
    synopsis:
      "一场大雪覆盖了整座城，也覆盖了所有未说出口的话。短片几乎没有对白，全靠眼神与呼吸完成叙事，在多个独立影展获得短片单元奖项。",
    featured: false,
  },
  {
    id: "w09",
    title: "追忆叙事曲",
    type: "电影",
    year: 2023,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20of%20a%20young%20japanese%20woman%20standing%20on%20an%20old%20wooden%20train%20platform%20at%20dusk%2C%20nostalgic%20warm%20orange%20sunlight%20mixed%20with%20deep%20blue%20gray%20shadows%2C%20soft%20film%20grain%2C%20melancholic%20memory%20mood%2C%20minimalist%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=okuda-work-09&orientation=portrait",
    director: "松本和也",
    role: "饰 水野沙罗",
    duration: "126 分钟",
    rating: 9.0,
    region: "日本",
    tags: ["剧情", "回忆", "音乐"],
    synopsis:
      "水野沙罗是一位钢琴调音师，她循着一首旧曲子寻找作曲者的下落。影片以音乐为线索串联起三代人的记忆，被认为是其职业生涯的巅峰之作。",
    featured: true,
  },
  {
    id: "w10",
    title: "等待春天的车站",
    type: "电视剧",
    year: 2023,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20of%20a%20young%20japanese%20woman%20standing%20on%20a%20rural%20train%20platform%20with%20cherry%20blossoms%20in%20bloom%2C%20soft%20pink%20and%20deep%20blue%20gray%20palette%20with%20warm%20orange%20accents%2C%20spring%20morning%20light%2C%20hopeful%20atmosphere%2C%20minimalist%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=okuda-work-10&orientation=portrait",
    director: "小林悠介",
    role: "饰 早川春",
    duration: "全 10 集",
    rating: 8.5,
    region: "日本",
    tags: ["治愈", "乡土", "成长"],
    synopsis:
      "早川春回到老家的小站工作，等待一班永远不会再来的列车，也等待一个也许还在的人。剧集用四季更替描绘了小镇的日常与温情。",
    featured: true,
  },
  {
    id: "w11",
    title: "遥远的约定",
    type: "电影",
    year: 2018,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20of%20a%20young%20japanese%20woman%20standing%20on%20a%20rocky%20coast%20near%20a%20white%20lighthouse%2C%20moody%20blue%20gray%20sea%20with%20warm%20orange%20sunset%20glow%2C%20windy%20dramatic%20sky%2C%20cinematic%20wide%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=okuda-work-11&orientation=portrait",
    director: "田中启介",
    role: "饰 宫本次女",
    duration: "110 分钟",
    rating: 7.8,
    region: "日本",
    tags: ["爱情", "剧情", "海岸"],
    synopsis:
      "灯塔下的那句约定，她等了整整十年。影片以海岸的四季为舞台，讲述一段跨越时间的重逢，是她早期大银幕作品中口碑最稳的一部。",
    featured: false,
  },
  {
    id: "w12",
    title: "海边的信",
    type: "短片",
    year: 2020,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20short%20film%20poster%20of%20a%20young%20japanese%20woman%20holding%20a%20letter%20on%20a%20quiet%20beach%20at%20dusk%2C%20muted%20blue%20gray%20ocean%20with%20warm%20orange%20sky%2C%20soft%20breeze%2C%20intimate%20serene%20mood%2C%20minimalist%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=okuda-work-12&orientation=portrait",
    director: "新井恭平",
    role: "饰 收信人",
    duration: "26 分钟",
    rating: 8.0,
    region: "日本",
    tags: ["短片", "海边", "书信"],
    synopsis:
      "一封没有寄出的信，被海浪一次次送回来。短片在同一个镜头机位下拍摄了日落的全过程，安静却充满力量。",
    featured: false,
  },
  {
    id: "w13",
    title: "光与影之间",
    type: "电视剧",
    year: 2024,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20of%20a%20young%20japanese%20woman%20standing%20in%20a%20room%20divided%20by%20harsh%20light%20and%20deep%20shadow%2C%20high%20contrast%20blue%20gray%20and%20warm%20orange%20tones%2C%20chiaroscuro%20lighting%2C%20tense%20dramatic%20mood%2C%20minimalist%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=okuda-work-13&orientation=portrait",
    director: "松本和也",
    role: "饰 桐生明里",
    duration: "全 9 集",
    rating: 8.7,
    region: "日本",
    tags: ["悬疑", "人性", "都市"],
    synopsis:
      "桐生明里拥有一个秘密：她能在梦里看见别人的选择。当这份能力开始反噬，她必须决定要不要继续当那个旁观者。剧集以强对比的光影风格成为年度讨论焦点。",
    featured: true,
  },
  {
    id: "w14",
    title: "融雪的清晨",
    type: "电影",
    year: 2024,
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20of%20a%20young%20japanese%20woman%20standing%20in%20a%20snow%20melting%20mountain%20village%20at%20dawn%2C%20cool%20blue%20gray%20snow%20with%20warm%20orange%20morning%20sun%2C%20rising%20mist%2C%20quiet%20hopeful%20atmosphere%2C%20minimalist%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=okuda-work-14&orientation=portrait",
    director: "田中启介",
    role: "饰 远野千鹤",
    duration: "121 分钟",
    rating: 8.8,
    region: "日本",
    tags: ["剧情", "乡土", "治愈"],
    synopsis:
      "雪化了，村子的路终于通了。远野千鹤在春天到来前回到故乡，处理一件迟到多年的告别。影片在雪景与晨光中完成了极其克制的情感表达。",
    featured: true,
  },
];